import { TFunction } from '@/types';
import { PHONE_REGEX } from '@/constants';
import * as Yup from 'yup';

export const FORM_INITIAL_VALUES = {
  title: '',
  formOfAddress: '',
  name: '',
  surname: '',
  desiredContactTime: '',
  email: '',
  phone: '',
  street: '',
  zipCode: '',
  city: '',
  comment: '',
  requestVisit: false,
  requestDetails: false,
  requestCall: false,
  requestSimilarObjects: false,
  // Todo: uncomment at 2.5 version release
  // requestSendCopyToMe: false,
  gdprAccepted: false,
  sendEmail: true,
  sendWhatsapp: false,
};

export const validationSchema = (t: TFunction) =>
  Yup.object({
    title: Yup.string(),
    formOfAddress: Yup.string(),
    name: Yup.string().required(t('form.required')),
    surname: Yup.string().required(t('form.required')),
    desiredContactTime: Yup.string(),
    email: Yup.string().email(t('form.wrongEmail')).required(t('form.required')),
    phone: Yup.string().when('sendWhatsapp', {
      is: true,
      then: (schema) =>
        schema.required(t('form.required')).matches(PHONE_REGEX, t('form.wrongPhone')),
      otherwise: (schema) =>
        schema
          .optional()
          .matches(PHONE_REGEX, t('form.wrongPhone'))
          .nullable()
          .transform((value) => (value === '' ? null : value)),
    }),
    street: Yup.string(),
    zipCode: Yup.string(),
    city: Yup.string(),
    comment: Yup.string().max(255, ({ max }) => t('form.maxLength', { max })),
    gdprAccepted: Yup.boolean().oneOf([true]).required(t('form.required')),
  });
